import { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate, Link } from "react-router-dom";
import { toast } from "react-toastify";
import Spinner from "../../components/spinner";
import { register } from "../../features/auth/authSlice";
import { reset } from "../../features/practitionerProfiles/practitionerProfileSlice";
import "../../styles/index.css";
import Logo from "../../img/LogoName.png";
import vec from "../../img/vectormodal.png";
import Logores from "../../img/logoresponsive.png";
import MultiSelect from 'react-multiple-select-dropdown-lite'
import 'react-multiple-select-dropdown-lite/dist/index.css'
import { MDBInput, MDBModal, MDBModalDialog, MDBModalContent, MDBModalBody, } from "mdb-react-ui-kit";
import { NewFooter } from "../../components/newFooter";
export function PractitionerSignUp() {
  const practitionerTypes = [
    "Gyno-urology",
    "Nurse Practitioner (ARNP)",
    "Nutritionist",
    "OBGYN",
    "Occupational Therapist (OT)",
    "Pain Management Doctor",
    "Pain Management Psychologist",
    "Pelvic Health Physical Therapist",
    "Physical Therapist Assistant (PTA)",
    "Physician (MD)",
    "Pilates Instructor",
    "Sex Coach / Therapist",
    "Women's Health Coach",
    "Women's Health Psychologist",
    "Women's Mental Health Therapist",
    "Yoga Instructor",
  ];

  const appointmentTypes = [
    "Virtual",
    "In Person",
    "Both"
  ]

  const options = [
    { label: 'Bladder & Bowel Incontinence', value: 'Bladder & Bowel Incontinence' },
    { label: 'Bladder Pain', value: 'Bladder Pain' },
    { label: 'Constipation', value: 'Constipation' },
    { label: 'Endometriosis', value: 'Endometriosis' },
    { label: 'Menopause & Perimenopause', value: 'Menopause & Perimenopause' },
    { label: 'Painful Sex', value: 'Painful Sex' },
    { label: 'Pelvic Organ Prolapse', value: 'Pelvic Organ Prolapse' },
    { label: 'Postpartum Recovery', value: 'Postpartum Recovery' },
    { label: 'Proactive Pelvic Care', value: 'Proactive Pelvic Care' },
    { label: 'Separated Abs', value: 'Separated Abs' },
    { label: 'Vaginoplasty Prep and Recovery', value: 'Vaginoplasty Prep and Recovery' },
  ]

  const countries = [
    { name: "United States" },
    { name: "United Kingdom & Ireland" }
  ]

  const regions = [
    {
      location: "Alabama",
      country: "United States"
    },
    {
      location: "Alaska",
      country: "United States"
    },
    {
      location: "Arizona",
      country: "United States"
    },
    {
      location: "Arkansas",
      country: "United States"
    },
    {
      location: "California",
      country: "United States"
    },
    {
      location: "Colorado",
      country: "United States"
    },
    {
      location: "Connecticut",
      country: "United States"
    },
    {
      location: "Delaware",
      country: "United States"
    },
    {
      location: "Florida",
      country: "United States"
    },
    {
      location: "Georgia",
      country: "United States"
    },
    {
      location: "Hawaii",
      country: "United States"
    },
    {
      location: "Idaho",
      country: "United States"
    },
    {
      location: "Illinois",
      country: "United States"
    },
    {
      location: "Indiana",
      country: "United States"
    },
    {
      location: "Iowa",
      country: "United States"
    },
    {
      location: "Kansas",
      country: "United States"
    },
    {
      location: "Kentucky",
      country: "United States"
    },
    {
      location: "Louisiana",
      country: "United States"
    },
    {
      location: "Maine",
      country: "United States"
    },
    {
      location: "Maryland",
      country: "United States"
    },
    {
      location: "Massachusetts",
      country: "United States"
    },
    {
      location: "Michigan",
      country: "United States"
    },
    {
      location: "Minnesota",
      country: "United States"
    },
    {
      location: "Mississippi",
      country: "United States"
    },
    {
      location: "Missouri",
      country: "United States"
    },
    {
      location: "Montana",
      country: "United States"
    },
    {
      location: "Nebraska",
      country: "United States"
    },
    {
      location: "Nevada",
      country: "United States"
    },
    {
      location: "New Hampshire",
      country: "United States"
    },
    {
      location: "New Jersey",
      country: "United States"
    },
    {
      location: "New Mexico",
      country: "United States"
    },
    {
      location: "New York",
      country: "United States"
    },
    {
      location: "North Carolina",
      country: "United States"
    },
    {
      location: "North Dakota",
      country: "United States"
    },
    {
      location: "Ohio",
      country: "United States"
    },
    {
      location: "Oklahoma",
      country: "United States"
    },
    {
      location: "Oregon",
      country: "United States"
    },
    {
      location: "Pennsylvania",
      country: "United States"
    },
    {
      location: "Rhode Island",
      country: "United States"
    },
    {
      location: "South Carolina",
      country: "United States"
    },
    {
      location: "South Dakota",
      country: "United States"
    },
    {
      location: "Tennessee",
      country: "United States"
    },
    {
      location: "Texas",
      country: "United States"
    },
    {
      location: "Utah",
      country: "United States"
    },
    {
      location: "Vermont",
      country: "United States"
    },
    {
      location: "Virginia",
      country: "United States"
    },
    {
      location: "Washington",
      country: "United States"
    },
    {
      location: "West Virginia",
      country: "United States"
    },
    {
      location: "Wisconsin",
      country: "United States"
    },
    {
      location: "Wyoming",
      country: "United States"
    },
    { location: "East Midlands, England", country: "United Kingdom & Ireland" },
    { location: "East of England, England", country: "United Kingdom & Ireland" },
    { location: "London, England", country: "United Kingdom & Ireland" },
    { location: "North East, England", country: "United Kingdom & Ireland" },
    { location: "North West, England", country: "United Kingdom & Ireland" },
    { location: "South East, England", country: "United Kingdom & Ireland" },
    { location: "South West, England", country: "United Kingdom & Ireland" },
    { location: "West Midlands, England", country: "United Kingdom & Ireland" },
    { location: "Yorkshire and The Humber, England", country: "United Kingdom & Ireland" },
  ]

  const [value, setvalue] = useState('')

  const handleOnchange = val => {
    const myArray = val.split(",")
    setFormData((prevState) => ({
      ...prevState,
      subSpecialty: myArray,
    }));
  }

  const handleOnchangeObject = e => {
    let newObject = {}
    if (e.target.value === "Virtual") {
      newObject = {
        virtual: true,
        inPerson: false,
      }
    } else if (e.target.value === "In Person") {
      newObject = {
        virtual: false,
        inPerson: true,
      }
    } else if (e.target.value === "Both") {
      newObject = { inPerson: true, virtual: true }
    }
    setFormData((prevState) => ({
      ...prevState,
      appointmentType: newObject,
    }));
  }
  const onChange = (e) => {
    setFormData((prevState) => ({
      ...prevState,
      [e.target.name]: e.target.value,
    }));
  };



  const [centredModal, setCentredModal] = useState(false);
  const toggleShow = () => setCentredModal(!centredModal);
  const [done, setDone] = useState(false);
  const [checked, setChecked] = useState(false);

  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    practiceName: "",
    practicePhoneNumber: "",
    practiceAddress: "",
    email: "",
    password: "",
    credentials: "",
    specialty: "",
    subSpecialty: [],
    location: "",
    appointmentType: {},
    country: "",

  });

  const {
    firstName,
    lastName,
    practiceName,
    practicePhoneNumber,
    practiceAddress,
    email,
    password,
    credentials,
    specialty,
    subSpecialty,
    location,
    appointmentType,
    country,
  } = formData;


  // const resetInputField = () => {
  //   setFormData("");
  // };

  const [countryDrop, setCountryDrop] = useState(true)
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { user, isLoading, isError, isSuccess, message } =
    useSelector((state) => state.auth);

  useEffect(() => {
    if (isError) {
      toast.error(message);
    }

    if (user) {
      navigate("/newPractitionerProfile");
    }

    dispatch(reset());
  }, [user, isError, isSuccess, message, navigate, dispatch]);

  useEffect(() => {
    const checkdata = (data) => {
      if (data?.password === "" || data?.email === "" || data?.firstName === "" || data?.lastName === "" || data?.credentials === "" || data?.specialty === "" || data?.location === "" || data?.subSpecialty?.length === 0 || checked === false || data?.practiceName === "" || data?.practicePhoneNumber === "" || data?.practiceAddress === "" || data?.country === "" || Object.entries(data?.appointmentType).length === 0) {
        setDone(false)
      } else {
        setDone(true)
      }

    }
    checkdata(formData)
  }, [formData, checked])



  // const onChangeArray = (e) => {

  //   setFormData((prevState) => ({
  //     ...prevState,
  //     subSpecialty: e.target.value,
  //   }));
  // };

  const onSubmit = (e) => {
    e.preventDefault();

    if (password?.length <= 8) {
      toast.error("Password does not meet requirements");
    } else {
      const practitionerUserData = {
        firstName,
        lastName,
        practiceName,
        practicePhoneNumber,
        practiceAddress,
        email,
        password,
        credentials,
        specialty,
        subSpecialty,
        location,
        appointmentType,
        country,
      };

      dispatch(register(practitionerUserData));
      // navigate("/practitionerLogin");
      setFormData({
        firstName: "",
        lastName: "",
        practiceName: "",
        practicePhoneNumber: "",
        practiceAddress: "",
        email: "",
        password: "",
        credentials: "",
        specialty: "",
        subSpecialty: [],
        location: "",
        appointmentType: {},
        country: "",
    
      })
      setChecked(!checked) 
    }
  };

  if (isLoading) {
    return <Spinner />;
  }
  console.log(formData)

  //Check initial width 

  const getWindowDimensions = () => {
    const { innerWidth: width } = window;
    return {
      width,
    };
  }
  const windowWidth = getWindowDimensions();
  console.log(windowWidth)

  return (
    <>
      <div>
        <section className=''>
          <form onSubmit={onSubmit}>
            <div className="signupGradient d-flex">
              <div className="bgwhite p-2 row ">
                {/* /////// first part logo and icon*/}
                {/* <div className="d-flex justify-content-between">
              <img src={Logo} className="logonew" alt="Elana Logo"></img>
            <div>
            <i class="fas fa-times"></i>
            </div> 
            </div> */}

                {/* /////// second part titles*/}

                <div className="text-center no-responsive-view pt-4">
                  <h2 className="titlesingup text-center m-0">Welcome to Elana</h2>
                  <p className="mb-2 text-dm">
                    Already have an account? Click <span onClick={() => navigate('/practitionerLogin')} className="pointer">here</span> to login
                  </p>
                </div>

                <div className="">
                  <div className=''>
                    {/* <div className=''>
                  <img src={Logores} className="Logores" alt='Elana Logo'></img>
                </div> */}
                    <div className='text-center no-bigscreen p-2'>
                      <h2 className="titlesingup text-center">Welcome to Elana</h2>
                      <p className="labelsingup text-center text-dm"> Already have an account? Click <span onClick={() => navigate('/practitionerLogin')}>here</span> to login</p>
                    </div>
                  </div>

                </div>



                <div className="margin-left">
                  <div className="d-flex justify-content-evenly m-1 row">
                    <div className="col-sm mt-2">
                      <label className="labelsingup text-muted text-dm">First Name</label>

                      <MDBInput
                        type="text"
                        className="form-control mdb"
                        id="form1"
                        name="firstName"
                        value={firstName}
                        onChange={onChange}
                        required
                      />
                    </div>

                    <div className="col-sm mt-2">
                      <label className="labelsingup text-muted text-dm">Last Name</label>
                      <MDBInput
                        type="text"
                        className="form-control mdb"
                        id="form1"
                        name="lastName"
                        value={lastName}
                        onChange={onChange}
                        required
                      />
                    </div>
                  </div>

                  <div className="d-flex justify-content-evenly m-1 row">
                    <div className="col-sm mt-2">
                      <label className="labelsingup text-muted text-dm">Practice Name</label>
                      <MDBInput
                        type="text"
                        className="form-control mdb"
                        id="form1"
                        name="practiceName"
                        value={practiceName}
                        onChange={onChange}
                        required
                      />
                    </div>

                    <div className="col-sm mt-2">
                      <label className="labelsingup text-muted text-dm">Practice Phone Number</label>
                      <MDBInput
                        type="text"
                        className="form-control mdb"
                        id="form1"
                        name="practicePhoneNumber"
                        value={practicePhoneNumber}
                        onChange={onChange}
                        required
                      />
                    </div>
                  </div>

                  <div className="d-flex justify-content-evenly m-1 row">
                    <div className="col-sm mt-2">
                      <label className="labelsingup text-muted text-dm">Email</label>
                      <MDBInput
                        type="text"
                        className="form-control col-sm mdb"
                        id="form1"
                        name="email"
                        value={email}
                        onChange={onChange}
                        required
                      />
                    </div>

                    <div className="col-sm mt-2">
                      <label className="labelsingup text-muted text-dm">Choose a Password <span className="smallLetters">(9 characters min.)</span></label>
                      <MDBInput
                        type="password"
                        className="form- mdb"
                        id="form1"
                        name="password"
                        value={password}
                        onChange={onChange}
                        required
                      />
                    </div>
                  </div>

                  <div className="d-flex justify-content-evenly m-1 row">
                    <div className="col-sm  mt-2">
                      <label className="labelsingup text-muted text-dm">Country</label>
                      <select
                        className="form-select mdb"
                        id="inputGroupSelect04"
                        aria-label="Example select with button addon"
                        name="country"
                        value={country}
                        onChange={onChange}
                        required
                      >
                        <option value="" className="text-muted">
                          -select one-
                        </option>
                        {countries.map((type, index) => {
                          return <option key={index} value={type.name} className="text-muted" onClick={() => {
                            setFormData({ ...formData, country: type.name })
                          }}>
                            {type.name}
                          </option>
                        })}
                      </select>
                    </div>

                    <div className="col-sm mt-2">
                      <label className="labelsingup text-muted text-dm">Location</label>
                      <select
                        className="form-select mdb"
                        id="inputGroupSelect04"
                        aria-label="Example select with button addon"
                        name="location"
                        value={location}
                        onChange={onChange}
                        required
                      >
                        <option value="0" className="text-muted text-dm">
                          -select one-
                        </option>
                        {regions.map((type, index) => {
                          console.log(formData)
                          if (type.country === country) {
                            return (<option key={index} value={type.location} className="text-muted text-dm" >
                              {type.location}
                            </option>
                            )
                          }
                        })}
                      </select>
                    </div>
                  </div>


                  <div className="row">
                    <div className="inputdrop col-sm col-md-12 mt-2">
                      <label className="labelsingup text-muted text-dm">Licensing Credentials </label>
                      <MDBInput
                        type="text"
                        className="form- mdb-large"
                        id="form1"
                        name="credentials"
                        value={credentials}
                        onChange={onChange}
                        required
                      />
                    </div>

                    <div className="inputdrop col-sm col-md-12 mt-2">
                      <label className="labelsingup text-muted text-dm">Practice Address</label>
                      <MDBInput
                        type="text"
                        className="form- mdb-large"
                        id="form1"
                        name="practiceAddress"
                        value={practiceAddress}
                        onChange={onChange}
                        required
                      />
                    </div>
                    <div className="inputdrop col-sm col-md-12 mt-2">
                      {/* <label className="labelsingup text-muted">Area of Specialty</label>
                  <div class="input-group mdb-large">
                    <select
                      className="form-select"
                      id="inputGroupSelect04"
                      aria-label="Example select with button addon"
                      name="specialty"
                      value={specialty}
                      onChange={onChange}
                      required
                    >
                      <option value="0" className="text-muted">
                        -select one-
                      </option>
                      {practitionerTypes.map((type, index) => {
                        return <option key={index} value={type} className="text-muted">
                          {type}
                        </option>
                      })}
                    </select>
                  </div> */}

                      <div className="dropdown d-grid">
                        <label className="labelsingup text-muted whitespace text-dm">
                          Specialty
                        </label>
                        {/* //dropdown-toggle  */}
                        {/* <div className=""> */}
                        <button className="btn btn-white m-0 padding-test "
                        //<span><i className="fas fa-angle-down float-end text-dark"></i></span>
                          type="button" id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false"> <span><i className="fas fa-angle-down float-end text-dark p-controller"></i></span>
                          <p className="text-start text-dm">{formData?.specialty}</p>
                          {/* {formData?.specialty} */}
                        </button>
                        {/* </div> */}
                        <ul className="dropdown-menu ul-overflow" aria-labelledby="dropdownMenuButton1" >
                          {practitionerTypes.map((type, index) => {
                            return <li key={index} className="text-muted li-hover p-1 text-dm" onClick={() => setFormData({ ...formData, specialty: type })}  >
                              {formData.specialty == type && <i className="fas fa-check me-1"></i>}
                              {type}
                            </li>
                          })}
                        </ul>
                      </div>

                    </div>
                    <div className="no-display-small mt-2">
                      <label className="labelsingup text-muted ms-3 text-dm">Sub-Specialty</label>
                      <div className="multiselect col-sm col-md-12">
                        <MultiSelect
                          // className="mdb-large"
                          style={{
                            width: "82%",
                            minWidth: '242px',
                            marginLeft: '15px',
                            borderRadius: "8px"
                            // fontFamily: 'Karla'
                          }}
                          onChange={handleOnchange}
                          //name="appointmentType"
                          //value={appointmentType}
                          // onChange={onChange}
                          options={options}
                        />
                      </div>
                    </div>

                    <div className="no-display-big mt-2">
                      <label className="labelsingup text-muted ms-2 text-dm">Sub-Specialty</label>
                      <div className="multiselect col-sm col-md-12">
                        <MultiSelect
                          // className="mdb-large"
                          style={{
                            width: "52%",
                            minWidth: '162px',
                            marginLeft: '15px',
                            fontFamily: "DM Sans"
                          }}
                          onChange={handleOnchange}
                          //name="appointmentType"
                          //value={appointmentType}
                          // onChange={onChange}
                          options={options}
                        />
                      </div>
                    </div>

                    <div className="inputdrop col-sm col-md-12 mt-2">
                      <label className="labelsingup text-muted text-dm">Appointment Type</label>
                      <div class="input-group mdb-large">
                        <select
                          className="form-select mb-2 "
                          id="inputGroupSelect04"
                          aria-label="Example select with button addon"
                          name="appointmentType"
                          // value={""}
                          onChange={handleOnchangeObject}
                          required
                        >
                          <option value="" className="text-muted text-dm text-grey">
                            -select one-
                          </option>
                          {appointmentTypes.map((type, index) => {
                            return <option key={index} value={type} className="text-muted text-dm">
                              {type}
                            </option>
                          })}
                        </select>
                      </div>
                    </div>


                  </div>
                </div>


                <div className="text-center center-responsive-checkbox mb-2">
                  <input type="checkbox" onChange={() => setChecked(!checked)}  className="checkbox-round m-1"></input>
                  <span className="span-register text-dm">
                    By creating an account, you have read and agree to our{" "}
                    <a className="a-tag-register" onClick={() => navigate('/Terms')}>Terms</a> and <a className="a-tag-register" onClick={() => navigate('/PrivacyPolicy')}>Privacy Policy</a>
                  </span>
                  <div className="text-center">
                    <button onClick={function () { toggleShow(); onSubmit(); }} className={done ? "button-active blue-hover mt-2 text-dm" : "button-disable mt-2 text-dm"} disabled={!done}>CONTINUE</button>

                    <MDBModal tabIndex='-1' show={centredModal} setShow={setCentredModal}>
                      <MDBModalDialog centered>
                        <MDBModalContent>
                          <MDBModalBody className="text-center">
                            <img src={vec} className="" alt="keep"></img>
                            <h1>Woohoo</h1>
                            <p>Your registration is complete. Please, check your email for confirmation information.</p>
                            <p>Next, let’s set up your profile.</p>
                            <Link to="/practitionerLogin"><button className="buttonmainpage px-1">LOGIN NOW</button></Link>
                          </MDBModalBody>
                        </MDBModalContent>
                      </MDBModalDialog>
                    </MDBModal>
                  </div>
                </div>



              </div>
            </div>
          </form>
        </section>
      </div>
      <NewFooter show={windowWidth.width < 500 ? false : true} />
    </>

  );
}
